module.exports = __webpack_public_path__ + "static/img/hezuo_bannerone_bg.ccfcf8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/enterpriseEdition/hezuo_bannerone_bg.png
// module id = BBA4
// module chunks = 14